import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { SupportService } from 'src/app/services/support.service';

@Component({
  selector: 'app-kb-category-manager',
  templateUrl: './kb-category-manager.component.html',
  styleUrls: ['./kb-category-manager.component.scss']
})
export class KbCategoryManagerComponent implements OnInit {
  @Output() back = new EventEmitter<void>();

  role = localStorage.getItem('role');
  categories: any[] = [];
  loading = false;

  newName = '';
  newOrder = 0;
  addingNew = false;

  editingId: string | null = null;
  editName = '';
  editOrder = 0;

  constructor(
    private supportService: SupportService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.loadCategories();
  }

  loadCategories(): void {
    this.loading = true;
    this.spinner.show('kb-cat-spinner');
    this.supportService.getKbCategories().subscribe({
      next: (res: any) => {
        this.categories = res.response?.data || [];
        this.loading = false;
        this.spinner.hide('kb-cat-spinner');
      },
      error: (err: any) => {
        this.loading = false;
        this.spinner.hide('kb-cat-spinner');
        this.toastr.error(err.error?.response?.message || 'Failed to load categories');
      }
    });
  }

  startEdit(cat: any): void {
    this.editingId = cat._id;
    this.editName = cat.name;
    this.editOrder = cat.order ?? 0;
  }

  cancelEdit(): void {
    this.editingId = null;
  }

  saveEdit(cat: any): void {
    if (!this.editName.trim()) {
      this.toastr.warning('Category name cannot be empty');
      return;
    }
    this.spinner.show('kb-cat-spinner');
    this.supportService.updateKbCategory(cat._id, { name: this.editName.trim(), order: this.editOrder }).subscribe({
      next: () => {
        this.editingId = null;
        this.toastr.success('Category updated');
        this.loadCategories();
      },
      error: (err: any) => {
        this.spinner.hide('kb-cat-spinner');
        this.toastr.error(err.error?.response?.message || 'Failed to update category');
      }
    });
  }

  addCategory(): void {
    if (!this.newName.trim()) {
      this.toastr.warning('Category name cannot be empty');
      return;
    }
    this.spinner.show('kb-cat-spinner');
    this.supportService.createKbCategory({ name: this.newName.trim(), order: this.newOrder }).subscribe({
      next: () => {
        this.newName = '';
        this.newOrder = 0;
        this.addingNew = false;
        this.toastr.success('Category created');
        this.loadCategories();
      },
      error: (err: any) => {
        this.spinner.hide('kb-cat-spinner');
        this.toastr.error(err.error?.response?.message || 'Failed to create category');
      }
    });
  }

  deleteCategory(cat: any): void {
    Swal.fire({
      title: 'Delete category?',
      text: `"${cat.name}" will be permanently removed. This will fail if articles still use this category.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      confirmButtonColor: '#d33'
    }).then(result => {
      if (!result.isConfirmed) { return; }
      this.spinner.show('kb-cat-spinner');
      this.supportService.deleteKbCategory(cat._id).subscribe({
        next: () => {
          this.toastr.success('Category deleted');
          this.loadCategories();
        },
        error: (err: any) => {
          this.spinner.hide('kb-cat-spinner');
          this.toastr.error(err.error?.response?.message || 'Failed to delete category');
        }
      });
    });
  }

  goBack(): void {
    this.back.emit();
  }
}
